import * as core from '../../../../../../../core'

import { query } from './change-impacts-by-validation-status.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.by.validation.status',
    description: 'Chart view of change impacts by validation status',
    name: 'Change Impacts by Validation Status',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
